import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { IconModule } from '@dx/web/shared/ui/icon';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import 'hammerjs';
import { HttpTokenInjector } from './Interceptor/http-token-injector';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormlyPanelComponent } from './formly-panel.component';
import { RepeatTypeComponent } from './formly-repeat.component';

@NgModule({
  declarations: [AppComponent, FormlyPanelComponent, RepeatTypeComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule,
    IconModule,
    MatNativeDateModule,
    FormlyMaterialModule,
    FormlyMatDatepickerModule,
    FormlyModule.forRoot({
      // wrappers: [
      //   {
      //     name: 'panel',
      //     component: FormlyPanelComponent
      //   }
      // ],
      // types: [
      //   {
      //     name: 'repeat',
      //     component: RepeatTypeComponent
      //   }
      // ]
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInjector, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}

// 95 lines
